import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import Button from '../../components/Button';
import { signOut } from '../../redux/actions';
var VerifyEmail = function () {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _a = useAppSelector(function (_a) {
        var auth = _a.auth;
        return { emailVerified: auth.emailVerified, isSignedIn: auth.isSignedIn };
    }), emailVerified = _a.emailVerified, isSignedIn = _a.isSignedIn;
    useEffect(function () {
        if (isSignedIn && !emailVerified)
            dispatch(signOut());
        else
            navigate('/');
    }, []);
    return (React.createElement("div", { className: 'm-4 flex w-full max-w-xs flex-col items-center gap-3' },
        React.createElement("p", { className: 'text-md text-center' }, "We sent you an email to your inbox. Please verify your email address in order to continue."),
        React.createElement(Button, { label: '\u2190 Back to Homepage', style: 'tertiary', onClick: function () { return navigate('/'); }, id: 'back' })));
};
export default VerifyEmail;
